module.exports = __webpack_public_path__ + "img/nathalie_de_loeper_praticienne_shiatsu-mobile.bd10b3a8.webp";